import React, { useRef } from 'react';
import { useLocation, useNavigationType, Outlet } from 'react-router-dom';
import styles from './PageTransition.module.scss';

export default function PageTransition() {
    const location = useLocation();
    const navType = useNavigationType();
    const isInitial = useRef(true);

    let className;
    if (isInitial.current) {
        className = styles.initial;
        isInitial.current = false;
    } else {
        className = navType === 'POP' ? styles.backward : styles.forward;
    }

    return (
        <div key={location.pathname} className={className}>
            <Outlet />
        </div>
    );
}
